// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const FileIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "File",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.19 10.56a2 2 0 0 0-.12-.35s0-.07 0-.07c-.06-.11-.14-.21-.22-.3l-7.53-7.5c-.08-.08-.18-.16-.29-.22s-.08 0-.08 0c-.1-.05-.21-.09-.33-.11S9 2.01 9 2.01c-2.31 0-4.18 1.86-4.21 4.16v20.1c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74V10.56h-.03Zm-2.81 15.7c0 .77-.76.97-1.4.97H8.99c-.64 0-1.4-.17-1.4-.97V6.16c0-.77.63-1.4 1.4-1.4h7.95V9.9c0 1.29 1.05 2.34 2.34 2.34h5.1z"
    })
  });
};